import React from 'react'
import PropTypes from 'prop-types'

import NearpodPickerAudio from './views/audio/nearpod_picker_audio'
import NearpodPickerAudioRecorder from './views/audio_recorder/nearpod_picker_audio_recorder'
import NearpodPickerGif from './views/gif/nearpod_picker_gif'
import NearpodPickerImage from './views/image/nearpod_picker_image'
import NearpodPickerPdf from './views/pdf/nearpod_picker_pdf'
import NearpodPickerVideo from './views/video/nearpod_picker_video'
import NearpodPickerWeb from './views/web/nearpod_picker_web'
import NearpodPickerInteractiveVideo from './views/interactive_video/nearpod_picker_interactive_video'

const NearpodPicker = props => {
	const pickerProps = {
		onFilesPicked: props.onFilesPicked,
		closeHandler: props.closeHandler,
		pickerType: props.pickerType,
		accept: props.accept,
		multiselect: props.multiselect,
		onFileError: props.onFileError,
		googleDrivePickerOrigin: props.googleDrivePickerOrigin,
	}

	switch (props.pickerType) {
		case 'audio':
			return <NearpodPickerAudio {...pickerProps} />
		case 'audio_recorder':
			return <NearpodPickerAudioRecorder {...pickerProps} />
		case 'gif':
			return <NearpodPickerGif {...pickerProps} />
		case 'image':
			return <NearpodPickerImage {...pickerProps} />
		case 'pdf':
			return <NearpodPickerPdf {...pickerProps} />
		case 'video':
			return <NearpodPickerVideo {...pickerProps} />
		case 'web':
			return <NearpodPickerWeb {...pickerProps} />
		case 'interactive_video':
			return <NearpodPickerInteractiveVideo {...pickerProps} />
		default:
			return null
	}
}

NearpodPicker.propTypes = {
	onFilesPicked: PropTypes.func.isRequired,
	closeHandler: PropTypes.func,
	pickerType: PropTypes.string,
	accept: PropTypes.array,
	multiselect: PropTypes.bool,
	onFileError: PropTypes.func,
	googleDrivePickerOrigin: PropTypes.string,
}

export default NearpodPicker
